<template>
  <div class="datos-ficha shadow">
    <div>
      <button type="button" class="close" aria-label="Close" @click="cerrarFicha">
        <span aria-hidden="true">&times;</span>
      </button>
      <img loading="lazy"
           :src="`${recursos}img/mountainhuts/${seleccion.friendly}/refuge-card-img.png`"
           :srcset="`${recursos}img/mountainhuts/${seleccion.friendly}/refuge-card-img@2x.png 2x`"
           class="card-img-top" style="max-height: 166px" alt="...">
    </div>
    <div class="card-body">
      <p class="card-title" :title="seleccion.name">
        {{ seleccion.name  }}
      </p>
    </div>
    <div class="card-footer">
      <a :href="`/mountainhut/${seleccion.friendly}.html`" target="_blank"
         class="btn btn-outline-info btn-block">{{texto.btnFicha}}</a>
    </div>
  </div>
</template>

<script>
import {appConfig} from "../config/app.conf";

export default {
  name: 'FichaRefugio',
  props: {
    seleccion: Object,
    texto: Object
  },
  data() {
    return {
      agregar: true,
      recursos: appConfig.resources
    }
  },
  methods: {
    cerrarFicha() {
      this.$emit('cerrarFicha');
    }
  }
}
</script>

<style scoped>
.datos-ficha {
  width: 250px;
  background-color: white;
  text-align: left;
  margin-bottom: 0;
}

.close {
  position: absolute;
  right: 5px;
  height: auto;
}
.table {
  margin-bottom: 0;

}
.table>:not(caption)>*>* {
  padding: 0;
}
.ascenso {
  transform: rotate(-45deg);
}
.descenso {
  transform: rotate(45deg);
}
</style>